// IMPORTANT! We should not add slick carousel here, because it is already added in app.js.
//require('slick-carousel');
const {onModeEnter, onModeLeave, getMode} = require('../../media.js');
import CustomizeThemeTemplates from "../booking-templates/customize-theme-templates"

new CustomizeThemeTemplates();




function loadMoreTemplates() {
    $(function () {
        var $countItems = $(".templates-items--list .templates-items--list-item");
        $countItems.slice(0, 9).show();

        $(".loadMoreItems").on('click', function (e) {
            e.preventDefault();
            $countItems.removeClass('scroll-here');
            $(".templates-items--list .templates-items--list-item:hidden").slice(0, 1).addClass('scroll-here');
            $(".templates-items--list .templates-items--list-item:hidden").slice(0, 3).slideDown();

            if ($(".templates-items--list .templates-items--list-item:hidden").length == 0) {
                $(".loadMoreItems").fadeOut('slow');
            }

            $('html,body').animate({
                scrollTop: $(".templates-items--list .templates-items--list-item.scroll-here").offset().top - 100
            }, 1500);
        });
    });
}

loadMoreTemplates();

function heroImageCarousel( selector ){
    if( $(selector).length ){
        selector.slick({
            dots: true,
            infinite: false,
            slidesToShow: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            fade: true,
            cssEase: 'linear',
            arrows: false,
            appendDots: $('.booking-templates-sections .picture--switcher')
        });
    }
}

if( getMode() != 'mob' ){
    //console.log('no mob - show slider')
    $('.book-templates--picture-wrapper').addClass('in');
    heroImageCarousel( $('.booking-templates-sections .picture--carousel') );
}
onModeEnter('mob', () => {
    $('.book-templates--picture-wrapper').removeClass('in');
    //console.log('enter to mob - hide slider')
});
onModeLeave('mob', () => {
    $('.book-templates--picture-wrapper').addClass('in');
    //console.log('no mob - show slider')
});